import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpOperatorFormData } from "../types";

export const NumberOfVehicleYouOwnAndOperateField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();

  return (
    <div className={clsx("flex flex-row items-center gap-x-2", className)} {...props}>
      <div className="flex w-full flex-col">
        <Typography variant="paragraph">How many vehicles do you own and operate?</Typography>
        <ErrorMessage errors={errors} name="numberOfVehiclesYouOwnAndOperate" />
      </div>
      <TextInput
        className="w-[72px] flex-1"
        type="number"
        placeholder="0"
        step="any"
        hasError={!!errors.numberOfVehiclesYouOwnAndOperate}
        {...register("numberOfVehiclesYouOwnAndOperate")}
      />
    </div>
  );
};
